import React from 'react';
import T from 'i18n-react';
import './CallToActionButton.css'
import { useSelector } from 'react-redux';
import { getIcon } from '../../../utils/IconUtil';

const CallToActionButton = (props) => {
    const lang = useSelector(state => state.layout.lang);

    return (
        <div className='call-to-action-button' id={props.buttonKey} onClick={() => props.onClick()}>
            <div className='call-to-action-button-icon'>
                {props.icon && <img src={getIcon(props.icon)} alt={props.icon} />}
            </div>
            <div className='call-to-action-button-label'>
                <h2>{T.translate(props.text, props.textProps)}</h2>
            </div>
            <div className='call-to-action-button-chevron'>
                <img src={getIcon('chevron-right')} alt='Continue' />
            </div>
        </div>
    );
};

export default CallToActionButton;